import React from 'react';

const Hero: React.FC = () => {
  // Using the Google User Content direct link format for the provided ID
  // This format is more reliable for direct image rendering in CSS/HTML
  const heroImageUrl = "https://lh3.googleusercontent.com/d/1uw-Towers_Xj7lxPzgAqdQ3EV6LycVSp";

  return (
    <section className="relative h-[85vh] flex items-center justify-center bg-stone-900 text-white overflow-hidden">
      {/* Background Image Container with Blur */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center opacity-40 grayscale scale-105 blur-[4px]"
        style={{ backgroundImage: `url(${heroImageUrl})` }}
      ></div>
      
      {/* Overlay for better contrast */}
      <div className="absolute inset-0 bg-stone-950/40 z-5"></div>
      
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <div className="mb-4 flex flex-col items-center">
          <span className="text-red-500 font-bold tracking-[0.5em] text-[10px] uppercase mb-2">Since 1992</span>
          <div className="h-px w-16 bg-red-800"></div>
        </div>

        <h1 className="text-5xl md:text-[6.5rem] font-serif font-black mb-6 leading-[0.9] tracking-tighter uppercase">
          Norm's<br/>
          Barber Shop
        </h1>

        <div className="h-1 w-24 barber-pole mx-auto mb-8 rounded-full"></div>

        <div className="mb-10 space-y-4">
          <p className="text-lg md:text-2xl font-serif italic opacity-90 text-stone-100 leading-tight">
            "Today's Cuts, Yesterday's Service."
          </p>
          <div className="pt-2">
            <p className="text-stone-200 uppercase tracking-[0.2em] text-lg md:text-2xl font-black italic border-y border-white/10 py-3 inline-block px-6">
              Over 100 Years of Combined Experience
            </p>
          </div>
        </div>

        <a 
          href="tel:3167218600"
          className="inline-flex items-center space-x-3 px-10 py-4 border-2 border-white text-white rounded-none font-bold uppercase tracking-[0.2em] transition-all hover:bg-white hover:text-stone-900 mt-2 text-sm group"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-red-500 group-hover:text-stone-900 transition-colors" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
          </svg>
          <span>Call Now: (316) 721-8600</span>
        </a>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center opacity-40 animate-bounce">
        <div className="w-px h-12 bg-gradient-to-b from-white to-transparent"></div>
      </div>
    </section>
  );
};

export default Hero;